import { MembershipPlansProps } from "modules/membership_plan/commercial_membership_plan/commercial_membership/store/actionType";
import {  EmailLogProps, stateStatusType } from "./actionType";

export interface FetchEmailLogsState {
  isLoading: boolean;
  error: string | null;
  emailLogs: EmailLogProps[] | null; // list
  status: stateStatusType | null;
}

export interface GenericEmailLogsState {
  isLoading: boolean;
  error: string | null;
  status: stateStatusType | null;
}


export const initalFetchEmailLogsState: FetchEmailLogsState = {
  isLoading: false,
  error: null,
  emailLogs: null,
  status: null,
};

export const initialGenericEmailLogsState: GenericEmailLogsState = {
  isLoading: false,
  error: null,
  status: null,
};

export interface EmailLogState {
  fetchEmailLogsState: FetchEmailLogsState;
  genericEmailLogsState : GenericEmailLogsState
}

export const initialState: EmailLogState = {
  fetchEmailLogsState: initalFetchEmailLogsState,
  genericEmailLogsState:initialGenericEmailLogsState
}

